//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        items: {
            type: Array,
            default: []
        },
        total: {
            type: Number,
            default: 0
        },
        building_id: {
            type: [Number, String]
        }
    },
    data() {
        return {
            current: 0
        }
    },
    methods: {
        goComments() {
            this.$sendCtmEvtLog('楼盘详情-热聊轮播点击', {building_id: this.building_id})
            this.$emit('goComments')
        },
        changeSwiper(index) {
            this.current = index
        }
    }
}
